<div class="edit-actions">
    <a (click)="onEdit.emit()" *ngIf="!editMode" class="edit-btn">Edit</a>
    <a (click)="onSave.emit()" *ngIf="editMode" class="save-btn">Save</a>
    <a (click)="onCancel.emit()" *ngIf="editMode" class="cancel-btn">Cancel</a>
</div>
